import React from 'react'
import { BooleanInput, FormDataConsumer, ReferenceArrayInput, SelectArrayInput } from 'react-admin'

// Must be a stable reference: redux-form re-registers the field (and loops) when validate changes every render.
const validateAssetTypes = (value, allValues, props) =>
  !allValues.globalField && (!value || value.length === 0) ? props.translate('main.asset_type_required') : undefined

// SimpleForm only injects record/resource into its direct children, so forward them to the nested inputs.
export const AssetTypeScopeInputs = (props) => (
  <>
    <BooleanInput source="globalField" {...props} />
    <FormDataConsumer {...props}>
      {({ formData, ...rest }) =>
        !formData.globalField && (
          <ReferenceArrayInput
            {...rest}
            source="assetTypeIds"
            reference="asset-types"
            perPage={1000}
            validate={validateAssetTypes}
          >
            <SelectArrayInput optionText="name" />
          </ReferenceArrayInput>
        )
      }
    </FormDataConsumer>
  </>
)
